import React from "react";
import {Link} from "react-router-dom";
import * as yup from "yup";
import {useFormik} from "formik";
import {useTranslation} from "react-i18next";

import {usePasswordRecoveryMutation} from "../query";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import MDInput from "materialDashboard/components/MDInput";
import {CircularProgress} from "@mui/material";
import MDLoadingButton from "../../../components/MDLoadingButton";


const ForgotPassword = () => {
    const {t} = useTranslation(['auth', 'validation']);
    const {mutateAsync, isLoading, isSuccess, isError} = usePasswordRecoveryMutation();

    const formik = useFormik({
        initialValues: {
            email: '',
        }, validationSchema: yup.object({
            email: yup
                .string()
                .email(t('validation:email'))
                .required(t('validation:required')),
        }),
        onSubmit: async (values) => {
            await mutateAsync(values.email);
        },
    });

    return <Card>
        <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
        >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                {t('forgotPassword.title')}
            </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
            {
                isError && <MDTypography color="error" align="center" variant="body2">
                    {t('forgotPassword.errorMsg')}
                </MDTypography>
            }
            {
                isSuccess ?
                    <MDBox mb={2}>
                        <MDTypography variant="body2" textAlign="center">
                            {t('forgotPassword.successMsg')}
                        </MDTypography>
                    </MDBox>
                    :
                    <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                        <MDBox mb={2}>
                            <MDInput type="email"
                                     label={t('forgotPassword.email')}
                                     name="email"
                                     value={formik.values.email}
                                     onChange={formik.handleChange}
                                     error={formik.touched.email && Boolean(formik.errors.email)}
                                     helperText={formik.touched.email && formik.errors.email}
                                     fullWidth/>
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDLoadingButton variant="gradient"
                                      color="info"
                                      fullWidth
                                      disabled={isLoading}
                                      startIcon={isLoading ? <CircularProgress size={20} color="inherit"/> : null}
                                      type="submit">
                                {t('forgotPassword.submit')}
                            </MDLoadingButton>
                        </MDBox>
                    </MDBox>
            }
            <MDBox mt={3} mb={1} textAlign="center">
                <MDTypography
                    component={Link}
                    to="/auth/sign-in"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                >
                    {t('forgotPassword.back')}
                </MDTypography>
            </MDBox>
        </MDBox>
    </Card>
}

export default ForgotPassword;